import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Heading, Text } from '../../components/ui'
import type { Contract } from '../../types/contratos'

type Props = {
  open: boolean
  contract: Contract | null
  busy?: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
}

const ContratosConfirmModal: React.FC<Props> = ({
  open,
  contract,
  busy = false,
  onClose,
  onConfirm,
}) => {
  if (!open || !contract) return null

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={() => !busy && onClose()} />
      <div className="relative z-10 flex w-full max-w-lg flex-col overflow-hidden rounded-xl bg-white shadow-xl dark:bg-gray-800">
        <div className="flex items-start justify-between gap-3 border-b border-gray-200 px-5 py-4 dark:border-gray-700">
          <div>
            <Heading as="h3" size="xl" className="text-gray-900 dark:text-white">
              Confirmar contrato
            </Heading>
            <Text size="sm" color="muted" className="mt-1">
              Após a confirmação, o rascunho não poderá mais ser editado.
            </Text>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50 dark:hover:bg-gray-700"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="px-5 py-5">
          <Text size="sm" className="text-gray-700 dark:text-gray-300">
            Confirmar o contrato{' '}
            <span className="font-semibold text-gray-900 dark:text-white">
              &ldquo;{contract.name}&rdquo;
            </span>
            ?
          </Text>
        </div>

        <div className="flex items-center justify-end gap-2 border-t border-gray-200 px-5 py-4 dark:border-gray-700">
          <Button type="button" variant="outline" onClick={onClose} disabled={busy}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="solid"
            onClick={() => void onConfirm()}
            disabled={busy}
          >
            {busy ? 'Confirmando...' : 'Confirmar contrato'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ContratosConfirmModal
